import { API } from "./api";

// Cache maps "kind:text" -> Promise<dataURI|null>
const cache = new Map();
let current = null;

export function audioKey(text, kind = "text") {
  return `${kind}:${text}`;
}

export function fetchAudio(text, kind = "text") {
  const key = audioKey(text, kind);
  if (cache.has(key)) return cache.get(key);
  const p = fetch(`${API}/tts?text=${encodeURIComponent(text)}&kind=${encodeURIComponent(kind)}`)
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => (d && d.audio ? `data:audio/mp3;base64,${d.audio}` : null))
    .catch(() => null);
  cache.set(key, p);
  return p;
}

export async function preload(items = []) {
  try {
    await Promise.all(items.map((i) => fetchAudio(i.text, i.kind || "text")));
  } catch (e) {
    /* ignore */
  }
}

function fallbackSpeak(text) {
  try {
    if (!("speechSynthesis" in window)) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 0.9;
    u.pitch = 1.2;
    window.speechSynthesis.speak(u);
  } catch (e) {
    /* ignore */
  }
}

export async function speak(text, kind = "text") {
  try {
    const src = await fetchAudio(text, kind);
    if (src) {
      if (current) {
        current.pause();
        current.currentTime = 0;
      }
      const a = new Audio(src);
      current = a;
      await a.play();
      return;
    }
  } catch (e) {
    /* fall through */
  }
  fallbackSpeak(text);
}

export const speakText = (t) => speak(t, "text");
export const speakWord = (w) => speak(w, "word");
export const speakPhoneme = (p) => speak(p, "phoneme");
